import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=014728a9&scoped=true&"
import script from "./commentList.vue?vue&type=script&lang=js&"
export * from "./commentList.vue?vue&type=script&lang=js&"
import style0 from "./commentList.vue?vue&type=style&index=0&id=014728a9&prod&lang=scss&scoped=true&"
import style1 from "./commentList.vue?vue&type=style&index=1&id=014728a9&prod&scoped=true&lang=css&"
import style2 from "./commentList.vue?vue&type=style&index=2&id=014728a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014728a9",
  null
  
)

export default component.exports